var React = require('react');

function CtaArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.96537 33.167C30.5878 33.9166 49.3618 21.0746 59.4412 1.80404","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M3.79331 32.5431C5.88906 30.7753 7.88204 28.9234 9.90013 27.0698","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M3.11816 33.4344C6.18682 34.7724 9.04812 36.3991 11.9072 38.1251","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

CtaArrowInline.defaultProps = {"width":"64","height":"40","viewBox":"0 0 64 40","fill":"none","role":"img","focusable":"false"};

module.exports = CtaArrowInline;

CtaArrowInline.default = CtaArrowInline;
